const NotFound = (props) => {
  return (
    <svg
      width={216}
      height={180}
      viewBox="0 0 216 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="notfound">
        <g id="404 SVg">
          <g id="Group 10">
            <path
              id="Body"
              d="M23.6887 136.137C22.1717 134.579 22.2056 132.085 23.7645 130.568L26.5872 127.821C28.1461 126.304 30.6396 126.338 32.1566 127.897L47.2741 143.432C47.783 143.955 48.2291 144.536 48.6034 145.162L53.1807 152.823C55.4554 156.63 52.2823 161.368 47.8961 160.715C47.6758 160.682 47.4724 160.578 47.317 160.419L23.6887 136.137Z"
              fill="#FCBF49"
              stroke="#6D6A75"
              strokeWidth={1.31285}
            />
            <path
              id="Right Arm"
              d="M10.8205 132.413L28.6134 152.27C30.0652 153.89 29.5249 156.454 27.5427 157.351C26.3579 157.886 24.9669 157.657 24.0173 156.768L4.54795 138.552C2.66519 136.79 2.69745 133.794 4.6177 132.073C6.42446 130.454 9.20156 130.606 10.8205 132.413Z"
              fill="#FCBF49"
              stroke="#6D6A75"
              strokeWidth={1.31285}
            />
            <path
              id="Left Arm"
              d="M52.906 137.66L31.5132 157.344C30.1428 158.605 28.0476 158.647 26.6277 157.442C24.9958 156.057 24.8809 153.579 26.3775 152.049L46.706 131.267C48.3408 129.596 50.9896 129.473 52.7721 130.986C54.8133 132.718 54.8761 135.847 52.906 137.66Z"
              fill="#FCBF49"
              stroke="#6D6A75"
              strokeWidth={1.31285}
            />
          </g>
          <g id="Group 11">
            <path
              id="Body_2"
              d="M186.504 89.7934C187.677 87.9936 190.087 87.4857 191.887 88.6589L195.146 90.7833C196.946 91.9566 197.454 94.3667 196.28 96.1665L184.588 114.102C184.195 114.706 183.732 115.262 183.21 115.758L176.82 121.83C173.645 124.847 168.391 122.817 168.069 118.449C168.053 118.23 168.109 118.011 168.229 117.827L186.504 89.7934Z"
              fill="#FCBF49"
              stroke="#6D6A75"
              strokeWidth={1.2967}
            />
            <path
              id="Right Arm_2"
              d="M187.303 76.5859L172.027 98.0367C170.78 99.787 168.192 99.8222 166.899 98.1065C166.125 97.081 166.045 95.6908 166.695 94.5832L180.028 71.8726C181.317 69.6764 184.212 69.0577 186.286 70.535C188.238 71.925 188.693 74.6341 187.303 76.5859Z"
              fill="#FCBF49"
              stroke="#6D6A75"
              strokeWidth={1.2967}
            />
            <path
              id="Left Arm_2"
              d="M191.372 118.278L167.766 101.931C166.254 100.884 165.759 98.8743 166.612 97.2448C167.593 95.372 169.956 94.7239 171.755 95.8344L196.188 110.917C198.153 112.13 198.845 114.656 197.774 116.702C196.547 119.044 193.546 119.783 191.372 118.278Z"
              fill="#FCBF49"
              stroke="#6D6A75"
              strokeWidth={1.2967}
            />
          </g>
          <g id="Man">
            <path
              id="Legs"
              d="M146.809 27.9626L121.364 70.3667C120.836 71.2469 119.792 71.6753 118.798 71.42L113.718 70.1157C103.521 67.4976 92.7574 71.3432 86.5283 79.8297C85.7022 80.9553 83.919 80.3891 83.8934 78.9931L82.6107 8.94814C82.5353 4.83225 85.8511 1.45515 89.9677 1.45515C93.1285 1.45515 95.6908 4.01746 95.6908 7.17825V47.0576C95.6908 54.7758 104.171 59.4895 110.726 55.4147C111.896 54.6875 112.9 53.7228 113.674 52.5829L122 40.3117L136.856 21.1531C138.064 19.5957 139.955 18.7253 141.924 18.8212C146.483 19.0431 149.158 24.0482 146.809 27.9626Z"
              fill="#F8F3E7"
              stroke="#6D6A75"
              strokeWidth={2}
            />
            <path
              id="Body_3"
              d="M120.473 125.003C120.473 127.715 118.31 129.933 115.599 130.001L89.5987 130.657C86.7888 130.728 84.4727 128.469 84.4727 125.659V97.9219C84.4727 94.2191 85.3654 90.571 87.0751 87.2866C92.5581 76.7537 105.087 72.0312 116.158 76.3239L117.857 76.9828C119.434 77.594 120.473 79.111 120.473 80.8018V125.003Z"
              fill="#FCBF49"
              stroke="#6D6A75"
              strokeWidth={2}
            />
            <path
              id="Right Arm_3"
              d="M68.319 94.45L67.9876 83.7554C67.861 79.6695 63.4575 77.1639 59.8804 79.1424C57.88 80.2487 56.7796 82.4832 57.122 84.7434L59.5283 100.623C60.0488 104.058 61.3844 107.318 63.4234 110.131L75.437 126.704C77.9375 130.153 83.0488 130.238 85.6617 126.872C87.5126 124.489 87.4444 121.136 85.4981 118.829L71.1423 101.817C69.3976 99.75 68.4028 97.1538 68.319 94.45Z"
              fill="#F8F3E7"
              stroke="#6D6A75"
              strokeWidth={2}
            />
            <path
              id="Right Arm_4"
              d="M135.409 156.3L133.315 166.092C132.393 170.405 136.437 174.126 140.659 172.849C142.93 172.162 144.553 170.16 144.754 167.795L146.084 152.211C146.407 148.413 145.749 144.595 144.172 141.125L136.017 123.18C134.169 119.114 128.99 117.87 125.497 120.653C122.879 122.739 122.149 126.411 123.771 129.34L134.203 148.183C135.571 150.655 135.999 153.537 135.409 156.3Z"
              fill="#F8F3E7"
              stroke="#6D6A75"
              strokeWidth={2}
            />
            <g id="Head">
              <path
                id="Ellipse 1"
                d="M85.9394 147.021C85.3345 144.022 85.7449 140.872 86.7476 137.875C89.7885 128.785 95.4749 121.355 104.474 121.355C108.679 121.355 111.767 122.649 114.168 124.915C116.6 127.212 118.397 130.574 119.859 134.828C121.545 139.735 121.873 145.059 120.232 149.884C117.582 157.68 112.499 163.312 104.474 163.312C95.2722 163.312 87.8351 156.418 85.9394 147.021Z"
                fill="#F8F3E7"
                stroke="#6D6A75"
                strokeWidth={2}
              />
              <path
                id="Vector 23"
                opacity={0.4}
                d="M118.749 153.562C119.119 153.27 119.274 152.722 119.378 152.122C119.604 150.813 119.181 149.086 118.187 148.206C115.86 146.499 113.167 145.311 110.336 144.753C106.49 143.995 102.505 144.403 98.8926 145.926L92.6057 148.574C92.027 148.818 91.5029 149.175 91.0641 149.625C89.1187 151.617 89.3152 154.852 91.4875 156.594L95.5005 159.812C98.7334 162.075 102.651 163.146 106.586 162.844L107 162.812C108.429 162.698 109.941 161.468 110.5 161.312C111.737 160.967 112.509 159.818 113.545 159.393C115.679 158.519 117.431 154.603 118.749 153.562Z"
                fill="#FC5E49"
                fillOpacity={0.69}
              />
            </g>
          </g>
        </g>
        <path
          id="Vector 50"
          opacity={0.65}
          d="M90 161.812C90.6877 162.719 91.4345 163.614 92.2321 164.424C92.4993 164.696 92.8791 164.889 92.4138 165.108C91.7527 165.419 90.8645 165.526 90.2682 165.938C89.7576 166.292 91.2838 167.128 91.4708 167.262C92.2004 167.788 92.2664 168.461 92.4916 169.287"
          stroke="#6D6A75"
          strokeLinecap="round"
        />
        <path
          id="Vector 51"
          opacity={0.25}
          d="M118.258 161.812C117.479 162.077 116.593 162.317 117.203 163.3C117.444 163.688 118.53 164.335 118.163 164.866C117.844 165.327 117.023 165.753 117.237 166.397C117.402 166.89 117.786 167.256 117.999 167.721C118.189 168.135 118.103 168.691 118.103 169.131"
          stroke="#6D6A75"
          strokeLinecap="round"
        />
        <path
          id="Vector 52"
          opacity={0.87}
          d="M98.9461 170.812C96.2702 171.795 100.172 172.633 99.6815 173.001C99.528 173.116 98.4445 173.387 98.7731 173.649C99.3993 174.15 100.205 174.379 100.971 174.549"
          stroke="#6D6A75"
          strokeLinecap="round"
        />
        <path
          id="Vector 53"
          opacity={0.65}
          d="M107.807 167.812C107.517 168.018 106.971 168.275 107.003 168.706C107.023 168.98 107.371 169.17 107.371 169.402C107.371 169.506 107.256 169.648 107.212 169.731C107.096 169.95 107.003 170.155 107 170.407C106.994 170.897 107.186 171.383 107.323 171.847"
          stroke="#6D6A75"
          strokeLinecap="round"
        />
        <path
          id="Vector 54"
          d="M80.0332 1.95514C78.3345 3.03154 77.6256 4.32849 77.0881 6.25999C76.8022 7.28747 76.7682 8.04047 77.1677 8.99945"
          stroke="#6D6A75"
          strokeLinecap="round"
        />
        <path
          id="Vector 55"
          d="M76.2127 1C74.8166 2.16968 73.2808 4.04466 72.7768 5.80897C72.4135 7.08033 72.7108 8.1944 73.2278 9.35765"
          stroke="#6D6A75"
          strokeLinecap="round"
        />
        <path
          id="Vector 56"
          d="M134.205 63.2906C132.741 66.8926 131.15 71.1269 127.052 72.298"
          stroke="#6D6A75"
          strokeLinecap="round"
        />
        <path
          id="Vector 57"
          d="M136.624 66.5822C136.158 67.9091 135.736 69.2409 134.986 70.4421C133.853 72.2581 132.344 73.894 130.735 75.2988C129.353 76.5047 127.928 77.1321 126.188 77.567"
          stroke="#6D6A75"
          strokeLinecap="round"
        />
        <path
          id="Vector 58"
          d="M65.1975 126.187C66.4635 112.166 68.5352 97.7688 62.702 84.4538C60.1068 78.5301 59.4829 71.7516 58.6323 65.3726"
          stroke="#6D6A75"
          strokeOpacity={0.09}
          strokeLinecap="round"
        />
        <path
          id="Vector 59"
          d="M58.978 117.548C57.0906 112.943 56.1276 108.792 55.9449 103.804C55.73 97.936 56.2696 91.976 55.465 86.1431C54.8193 81.4614 53.0412 77.1942 51.453 72.7824C49.5789 67.5767 48.9101 62.5517 48.2664 57.0797"
          stroke="#6D6A75"
          strokeOpacity={0.09}
          strokeLinecap="round"
        />
        <path
          id="Vector 60"
          d="M146.744 104.764C150.706 95.2376 154.455 85.6075 160.009 76.8712C162.884 72.3491 165.61 68.0461 167.457 62.9922C170.499 54.6661 170.586 46.5138 170.586 37.7297"
          stroke="#6D6A75"
          strokeOpacity={0.09}
          strokeLinecap="round"
        />
        <path
          id="Vector 61"
          d="M160.565 56.3886C162.95 48.9218 164.982 41.4671 166.939 33.8904C168.194 29.027 169.45 24.2984 172.314 20.1074C174.223 17.3136 176.598 15.2013 178.802 12.6975C180.247 11.0563 181.068 8.93356 181.989 6.97699"
          stroke="#6D6A75"
          strokeOpacity={0.09}
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default NotFound;
